import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface RunGiftRecord {
  id: number;
  box_id: number;
  box_info_id: number;
  box_info_name: string;
  user_id: number;
  user_nickname: string;
  user_mobile: string;
  product_name: string;
  product_recycle_price: number;
  range_from: number;
  range_to: number;
  created_at: string;
}

@Module
export default class RunGiftRecordModule extends VuexModule {
  run_gift_records_list = [] as Array<RunGiftRecord>;
  run_gift_records_count = 0;

  get currentRunGiftRecordsList(): Array<RunGiftRecord> {
    return this.run_gift_records_list;
  }

  get currentRunGiftRecordsCount(): number {
    return this.run_gift_records_count;
  }

  @Mutation
  [Mutations.SET_RUN_GIFT_RECORDS_LIST](records_list: Array<RunGiftRecord>) {
    this.run_gift_records_list = records_list;
  }

  @Mutation
  [Mutations.SET_RUN_GIFT_RECORDS_COUNT](count: number) {
    this.run_gift_records_count = count;
  }

  @Action
  [Actions.GET_RUN_GIFT_RECORDS](params: Record<string, unknown>) {
    ApiService.setHeader();

    let queryString = "?";
    if (params) {
      Object.keys(params).forEach((key) => {
        if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
          queryString += "&" + key + "=" + params[key];
        }
      });
    }

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/run_gift_records", queryString)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_RUN_GIFT_RECORDS_LIST, data["run_gift_records"] || []);
          this.context.commit(Mutations.SET_RUN_GIFT_RECORDS_COUNT, data["total_result"] || 0);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }
}
